import { ApaduaAPI } from './ApaduaAPI';

export class ElasticSearchAPI extends ApaduaAPI {
    resource = `/esproxy/default/${window.ELASTICSEARCH_INDEX_NAME}`;

    count(): Promise<any> {
        return this.get('/_count');
    }
}
